import { hasCapability } from "@/utils/capability";

import { usePlatformCapabilities } from "../capability/usePlatformCapabilities";

/**
 * Whether the current user may edit the current platform's settings
 * (`PLATFORM_SETTINGS:WRITE` on the platform capability set). Strict RBAC — the
 * S0 grants give platform owners (via the owner `'*'` bundle), platform managers
 * (bundle key) and admins (full vocabulary) the key, matching the personas the
 * former legacy predicate admitted. See docs/capabilities.md.
 */
export const useCanAccessPlatformSettings = () => {
  const platformCapabilities = usePlatformCapabilities();

  return hasCapability(platformCapabilities, "PLATFORM_SETTINGS:WRITE");
};
